export default __webpack_public_path__ + "static/media/wifi_off.97abbae4.svg";